<template>
  <BaseLayout>
    <div class="mx-auto my-[72px] max-w-3xl px-6">
      <h1
        class="mb-[43px] border-b border-b-gpx_gray-800 pb-[17px] text-gpx_2xl font-semibold text-gpx_black-500"
      >
        New Shipment
      </h1>
      <ShipmentCreateWizard :key="$route.fullPath" />
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/BaseLayout.vue';
import ShipmentCreateWizard from '@/components/shipment/create/ShipmentCreateWizard.vue';

export default {
  components: {
    BaseLayout,
    ShipmentCreateWizard,
  },
};
</script>
